// Tier-3 builder presentation seam (Phase 4, mechanical extraction).
//
// Renders the autosave status label that the three builders already derive
// themselves. The label derivation stays in each container -- this component
// never reads draftMetadata, never subscribes to a builder context and never
// decides what "Saved" means.
export default function SaveStatusPill({
  label,
  as: Element = "span",
  className = "",
}) {
  return (
    <Element
      className={[className, "lz-builder-save-status"].filter(Boolean).join(" ")}
    >
      {label}
    </Element>
  );
}
